import { render } from "./LabelModal.vue?vue&type=template&id=29dcd351&scoped=true"
import script from "./LabelModal.vue?vue&type=script&lang=js"
export * from "./LabelModal.vue?vue&type=script&lang=js"

import "./LabelModal.vue?vue&type=style&index=0&id=29dcd351&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29dcd351"]])

export default __exports__